/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { AppointmentActionResponse, CancelAppointmentsApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    cancelAppointments: build.mutation<AppointmentActionResponse, CancelAppointmentsApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PATCH',
        url: `/v1/appointments/cancel`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as cancelAppointmentsApi };
export const { useCancelAppointmentsMutation } = injectedRtkApi;
